module.exports = __webpack_public_path__ + "static/media/DINNextLTProUltraLightCond.1e288b43.woff";